// ------------------------------------
// Imports
// ------------------------------------
import {
  fetchUserCommunicationPreferencesApi,
  updateUserCommunicationPreferencesApi
} from 'api/communicationPreferences';

import { notify } from './notice';
// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_COMMUNICATION_PREFERENCES_START = 'FETCH_COMMUNICATION_PREFERENCES_START';
export const FETCH_COMMUNICATION_PREFERENCES_END = 'FETCH_COMMUNICATION_PREFERENCES_END';
export const UPDATE_COMMUNICATION_PREFERENCES = 'UPDATE_COMMUNICATION_PREFERENCES';
export const ERROR_COMMUNICATION_PREFERENCES = 'ERROR_COMMUNICATION_PREFERENCES';
// ------------------------------------
// Actions
// ------------------------------------
export function fetchCommunicationPreferencesStart() {
  return ({ type: FETCH_COMMUNICATION_PREFERENCES_START });
}

export function fetchCommunicationPreferencesEnd() {
  return ({ type: FETCH_COMMUNICATION_PREFERENCES_END });
}

export function updateCommunicationPreferencesAction(payload) {
  return ({ type: UPDATE_COMMUNICATION_PREFERENCES, payload });
}

export function raiseCommunicationPreferencesError() {
  return ({ type: ERROR_COMMUNICATION_PREFERENCES });
}

export function getUserCommunicationPreferences() {
  return (dispatch) => {
    dispatch(fetchCommunicationPreferencesStart());
    fetchUserCommunicationPreferencesApi()
      .then((res = {}) => {
        dispatch(updateCommunicationPreferencesAction(res.body));
        dispatch(fetchCommunicationPreferencesEnd());
      })
      .catch((error) => {
        dispatch(notify({ error }));
        dispatch(raiseCommunicationPreferencesError());
        dispatch(fetchCommunicationPreferencesEnd());
      });
  };
}

export function updateUserCommunicationPreferences(args) {
  return (dispatch) => {
    updateUserCommunicationPreferencesApi(args)
      .then((res = {}) => {
        dispatch(updateCommunicationPreferencesAction(args));
        dispatch(notify({ message: "Email Preferences have been saved." }));
      })
      .catch((error) => {
        dispatch(raiseCommunicationPreferencesError());
        dispatch(notify({ error }));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/communicationPreferences.js